import { z } from 'zod';
import { ExportStatus } from '../helpers/constants';

// API response validation schema
export const historyApiResponseSchema = z.object({
  filters: z
    .array(
      z.object({
        url: z.string(),
        name: z.string()
      })
    )
    .optional(),
  total_records: z.number(),
  no_of_records_per_page: z.number(),
  data: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      company_id: z.number(),
      status: z.enum([
        ExportStatus.PENDING,
        ExportStatus.COMPLETED,
        ExportStatus.ERROR,
        ExportStatus.UNKNOWN
      ]),
      generated_at: z.number(),
      generated_for: z.object({
        start_date: z.number(),
        end_date: z.number(),
        location_ids: z.array(z.number()),
        staff_id: z.number(),
        staff_name: z.string()
      }),
      download_url: z.string().nullable(),
      expiry_date: z.number().nullable().optional()
    })
  )
});

export type ValidatedHistoryApiResponse = z.infer<typeof historyApiResponseSchema>;
